module.exports = new __parcel__URL__("arrow-right.b6c3437d.svg").toString();